<template>
  <section class="mt-2 px-4 lg:px-8">
    <div class="mx-auto flex w-full max-w-5xl justify-between" v-bind="$attrs">
      <slot></slot>
    </div>
  </section>
</template>
